// Formatação de números para a interface.
// Enquanto um cálculo não tem todos os dados, o resultado é NaN/Infinity — nesses casos
// exibimos um travessão em vez de "NaN".
export const formatarNumero = (valor, casas = 1, padrao = '—') => {
  const numero = typeof valor === 'number' ? valor : Number(String(valor ?? '').replace(',', '.'));
  return Number.isFinite(numero) ? numero.toFixed(casas) : padrao;
};

export default formatarNumero;
